<template>
  <div class="bjtp">
    <!-- side -->
    <div>
      <navi></navi>
    </div>
    <!-- main -->
    <div style="padding: 0 270px;margin-bottom:70px">
      <el-row :gutter="20">
        <div
          style="margin-top: 120px;border: 1px solid #c9c9c9;width: 100%;padding: 20px 20px;display: inline-block;border-radius:10px;background: white;min-height: 42.79rem;"
        >
          <!-- 搜索框部分 -->
          <div class="search-con">
            <div class="input-con">
              <input type="text" :placeholder="placeholder" v-model="placeholderModel" />
            </div>
            <el-button type="primary" id="btn" @click="search" style="border-radius: 2px;">搜索</el-button>
          </div>
          <el-form ref="form" :model="form">
            <el-form-item label="类型">
              <el-radio-group v-model="radio" style="line-height: 50px;" @change="radioChange">
                <!-- <el-radio label="1"><span @click="qb">全部</span></el-radio> -->
                <el-radio label="2">智库机构</el-radio>
                <el-radio label="3">机构成员</el-radio>
                <el-radio label="4">涉华重点</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--智库-->
            <div v-show="show2" v-loading="loading">
              <div class="tujian">
                <div class="zdry_label">
                  <div v-if="objectList.length == 0" style="height:50px;">
                    <!-- <span class="null-data-span">未查询到结果</span> -->
                  </div>
                  <div v-if="objectList.length > 0" class="zcdt_l_right">
                    <table>
                      <tr
                        v-for="(p, index) in objectList"
                        :key="index"
                        @click="zkjg_sy(p.id)"
                        style="cursor:pointer;"
                      >
                        <td>
                          <img
                            :src="'data:image/png;base64,' + p.avatar"
                            :onerror="defaultImg"
                            style="width:120px;height:100px;"
                          />
                        </td>
                        <td style="padding-left: 20px">
                          <!-- <span style="font-size: 20px">{{ p.name }}</span><br> -->
                          <!-- <span v-if="p.address">{{ p.address }}<br></span> -->
                          <!-- <span class="clamp">{{ p.introductory }}</span> -->
                          <span style="font-size: 20px" v-html="brightenKeyword(p.name)"></span>
                          <br />
                          <span v-if="p.address" v-html="brightenKeyword(p.address)"></span>
                          <br />
                          <span class="clamp" v-html="brightenKeyword(p.introductory)"></span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--人员-->
            <div v-show="show3" v-loading="loading">
              <div class="tujian">
                <div class="zdry_label">
                  <div v-if="objectList.length == 0" style="height:50px;">
                    <!-- <span class="null-data-span">未查询到结果</span> -->
                  </div>
                  <div v-if="objectList.length > 0" class="zcdt_l_right">
                    <table>
                      <tr
                        v-for="(p, index) in objectList"
                        :key="index"
                        @click="rwxq(p.id)"
                        style="cursor:pointer;"
                      >
                        <td>
                          <img
                            :src="'data:image/png;base64,' + p.imgcode"
                            alt
                            :onerror="defaultImg"
                            style="width:100px;height:100px;"
                          />
                        </td>
                        <td style="padding-left: 20px">
                          <!-- <span style="font-size: 20px">{{ p.name }}</span>
                                                    <span class="huaTitle" v-if="p.ishua == 1">涉华</span><br>
                                                    <span>{{ p.address }}</span><br>
                                                    <span style="color: #a0a0a0">{{ p.position }}</span>
                          <span style="color: #a0a0a0">,{{ p.industry }}</span>-->
                          <span style="font-size: 20px" v-html="brightenKeyword(p.name)"></span>
                          <span class="huaTitle" v-if="p.ishua == 1">涉华</span>
                          <br />
                          <span v-html="brightenKeyword(p.address)"></span>
                          <br />
                          <span style="color: #a0a0a0" v-html="brightenKeyword(p.position)"></span>
                          <span>,</span>
                          <span style="color: #a0a0a0" v-html="brightenKeyword(p.industry)"></span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--涉华人员-->
            <div v-show="show4" v-loading="loading">
              <div class="tujian">
                <div class="zdry_label">
                  <div v-if="objectList.length == 0" style="height:50px;">
                    <!-- <span class="null-data-span">未查询到结果</span> -->
                  </div>
                  <div v-if="objectList.length > 0" class="zcdt_l_right">
                    <table>
                      <tr
                        v-for="(p, index) in objectList"
                        :key="index"
                        @click="rwxq(p.id)"
                        style="cursor:pointer;"
                      >
                        <td>
                          <img
                            :src="'data:image/png;base64,' + p.imgcode"
                            alt
                            :onerror="defaultImg"
                            style="width:100px;height:100px;"
                          />
                        </td>
                        <td style="padding-left: 20px">
                          <!-- <span style="font-size: 20px">{{ p.name }}</span>
                                                    <span class="huaTitle">涉华</span><br>
                                                    <span>{{ p.address }}</span><br>
                                                    <span style="color: #a0a0a0">{{ p.position }}</span>
                          <span style="color: #a0a0a0">,{{ p.industry }}</span>-->
                          <span style="font-size: 20px" v-html="brightenKeyword(p.name)"></span>
                          <span class="huaTitle">涉华</span>
                          <br />
                          <span v-html="brightenKeyword(p.address)"></span>
                          <br />
                          <span style="color: #a0a0a0" v-html="brightenKeyword(p.position)"></span>
                          <span>,</span>
                          <span style="color: #a0a0a0" v-html="brightenKeyword(p.industry)"></span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页器 -->
            <div
              style="text-align: center;margin-top: 20px;display:flex;justify-content:center;"
              v-if="total > 0"
            >
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page="where.page"
                :page-size="10"
                :total="total"
              ></el-pagination>
              <div style="display: flex;align-items:center;" v-show="show2">
                总计&nbsp;
                <span style="color: #256ee5;">{{ total }}</span>&nbsp;官网
              </div>
              <div style="display: flex;align-items:center;" v-show="show3">
                总计&nbsp;
                <span style="color: #256ee5;">{{ total }}</span>&nbsp;成员
              </div>
              <div style="display: flex;align-items:center;" v-show="show4">
                总计&nbsp;
                <span style="color: #256ee5;">{{ total }}</span>&nbsp;涉华成员
              </div>
            </div>
          </el-form>
        </div>
      </el-row>
    </div>
    <!-- side -->
    <div style="position: fixed;left: 0px;bottom: 0px;width: 100%;">
      <foot></foot>
    </div>
  </div>
</template>

<script>
import navi from "../components/navi";
import foot from "../components/foot";
import { getPersonsPage, getHuaPersonsPage } from "@/api/persons";
import { zhSearchOrganPage } from "@/api/organization";

export default {
  name: "zhSearch",
  components: {
    navi,
    foot
  },
  data() {
    return {
      /*显示隐藏*/
      show2: false,
      show3: true,
      show4: false,
      form: {},
      radio: "3",
      placeholder: "请输入关键字搜索_可以使用英文逗号进行搜索词分割",
      placeholderModel: "",
      where: {
        search: "",
        page: 1
      },
      objectList: [], //列表
      total: 0, //总量
      defaultImg:
        'this.src="' + require("../../static/images/defult_head.png") + '"', //默认图像
      loading: true
    };
  },
  created() {
    if (this.$route.query.name == undefined) {
      if (this.$route.query.radio != undefined) {
        this.radio = this.$route.query.radio;
        if (this.radio == "2") {
          this.show2 = true;
          this.show3 = false;
          this.show4 = false;
        } else if (this.radio == "3") {
          this.show2 = false;
          this.show3 = true;
          this.show4 = false;
        } else if (this.radio == "4") {
          this.show2 = false;
          this.show3 = false;
          this.show4 = true;
        }
      }
    } else {
      this.radio = "3";
      this.show2 = false;
      this.show3 = true;
      this.show4 = false;
      this.placeholderModel = this.$route.query.name;
    }
    this.search();
  },
  methods: {
    //搜索高亮
    brightenKeyword(val) {
      if (val && this.gaoLiangKeyword) {
        // 根据英文逗号分隔关键词
        const keywords = this.gaoLiangKeyword.split(",");
        // 遍历关键词数组，依次高亮匹配的内容
        keywords.forEach(keyword => {
          if (keyword.trim()) {
            const reg = new RegExp(keyword.trim(), "ig");
            val = val.replace(reg, match => {
              return `<span style="color: red; font-size: 15px;">${match}</span>`;
            });
          }
        });
        return val;
      }
      return val;
    },
    /**
     * 切换及查询
     */
    radioChange() {
      let type = this.radio;
      if (type == "2") {
        this.show2 = true;
        this.show3 = false;
        this.show4 = false;
        this.placeholder = "请输入关键字搜索";
        this.search();
      } else if (type == "3") {
        this.show2 = false;
        this.show3 = true;
        this.show4 = false;
        this.placeholder = "请输入关键字搜索_可以使用英文逗号进行搜索词分割";
        this.search();
      } else if (type == "4") {
        this.show2 = false;
        this.show3 = false;
        this.show4 = true;
        this.placeholder = "请输入关键字搜索_可以使用英文逗号进行搜索词分割";
        this.search();
      }
    },
    search() {
      this.loading = true;
      this.where.search = this.placeholderModel;
      this.where.page = 1;
      if (this.radio == "3") {
        this.queryPersons();
      } else if (this.radio == "4") {
        this.queryHuaPersons();
      } else {
        this.queryOrgan();
      }
    },
    //查询智库
    async queryOrgan() {
      let organs = await zhSearchOrganPage(this.where);
      // console.log("organs", organs);
      this.objectList = organs.data;
      this.total = organs.count;
      this.loading = false;
    },

    //查询人员
    async queryPersons() {
      let persons = await getPersonsPage(this.where);
      // console.log("persons", persons);
      this.objectList = persons.data;
      this.total = persons.count;
      this.loading = false;
    },
    //查询涉hua人员
    async queryHuaPersons() {
      let huaPersons = await getHuaPersonsPage(this.where);
      // console.log("huaPersons", huaPersons);
      this.objectList = huaPersons.data;
      this.total = huaPersons.count;
      this.loading = false;
    },
    /**
     * 点击下一页方法
     * @param {*} page
     */
    handleCurrentChange(page) {
      this.where.page = page;
      if (this.radio == "3") {
        this.queryPersons();
      } else if (this.radio == "4") {
        this.queryHuaPersons();
      } else {
        this.queryOrgan();
      }
    },

    /**
     * 点击人员跳转人员详情页面
     * @param {*} id
     */
    rwxq(id) {
      // console.log("placeholderModel",this.placeholderModel);
      if (this.placeholderModel == null || this.placeholderModel == "") {
        let routeData = this.$router.resolve({
          path: "/rwxq",
          query: { personid: id }
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          path: "/rwxq",
          query: { personid: id, where: this.placeholderModel }
        });
        window.open(routeData.href, "_blank");
      }
    },

    /**
     * 点击跳转智库详情页面
     * @param {*} id
     */
    zkjg_sy(id) {
      let routeData = this.$router.resolve({
        path: "/zkjg",
        query: { companyId: id }
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: 'zygw', params: { companyId: id }})
    }
  }
};
</script>

<style lang="less">
.bjtp {
  overflow-x: hidden;
  min-height: 800px;
  background: linear-gradient(
    to bottom,
    #3f48cc 0%,
    #3f48cc 285px,
    #f0f8ff 285px,
    #f0f8ff 100%
  );
  // background: url(../../static/images/background.png);
  // background-size: contain;
}

.huaTitle {
  line-height: 14px;
  display: inline-block;
  border: 1px solid rgb(90, 114, 235);
  padding: 2px 12px;
  border-radius: 11px;
  color: rgb(90, 114, 235);
  margin-left: 15px;
  font-size: 12px;
}

.clamp {
  color: #a0a0a0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 800px;
  display: block;
}

// 搜索框样式
.search-con {
  width: 800px;
  height: 40px;
  margin: 20px auto;
  border: 0px solid #000;

  .el-select {
    width: 100px;
    height: 40px;
    vertical-align: middle;

    .el-input {
      .el-input__inner {
        border: 1px solid #d5dbe6;
        // border-right: 0;
        border-radius: 0px;
        height: 40px;
        line-height: 40px;
      }

      .el-input__suffix {
        height: 40px;

        .el-input__icon {
          line-height: 40px;
        }
      }
    }
  }

  .input-con {
    display: inline-block;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    outline: 0;
    border: 1px solid #d5dbe6;
    width: 550px;
    vertical-align: middle;
    background: #fff;
    margin-left: -1px;
    border-radius: 2px;

    input {
      height: 25px;
      width: 550px;
      outline: 0;
      border: 0;
      border-left: 0;
      padding-left: 20px;
    }
  }

  .el-button--primary {
    border: 0;
    border-radius: 0;
    height: 40px;
    vertical-align: middle;
    background: #256ee5;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/zhSearch.vue